import React from 'react'
import styles from './Button.module.scss'

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'inverse'
export type ButtonSize = 'small' | 'medium' | 'large'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  children: React.ReactNode
}

/**
 * Action button component
 * 
 * Variants:
 * - primary: Green button (default, main actions)
 * - secondary: Gray button (secondary actions)
 * - danger: Red button (destructive actions)
 * - inverse: Button for dark backgrounds (header, etc.)
 * 
 * Sizes:
 * - small: Compact button
 * - medium: Default size
 * - large: Prominent button
 */
export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  children,
  className = '',
  ...props
}) => {
  return (
    <button
      className={`${styles.button} ${styles[variant]} ${styles[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
